const solutions = {
  title: 'Industry Solutions',
  subtitle: 'Customized payment solutions tailored to different industry characteristics',
  painPoints: 'Industry Pain Points',
  solutionTitle: 'Solutions',
  benefits: 'Value Benefits',
  caseStudies: 'Success Stories',
  caseStudiesDesc: 'The following are example cases. Please contact us for actual case details',
  challenge: 'Challenge:',
  result: 'Result:',
  ctaTitle: 'Find the Right Solution for You',
  ctaSubtitle: 'Our expert team will customize the optimal payment strategy for you',
  ctaButton: 'Free Consultation',
  industries: {
    ecommerce: {
      title: 'Cross-border E-commerce',
      subtitle: 'DTC/Platform Merchants',
      painPoints: [
        'Regional payment preference differences',
        'Chargeback and risk control challenges',
        'Low settlement efficiency',
        'Insufficient localization experience'
      ],
      solutions: [
        'Unified API access to multiple payment methods',
        'Local payment combination optimization',
        'Smart risk control strategy templates',
        'Real-time exchange rates and settlement'
      ],
      benefits: [
        'Increase conversion rate by 15-30%',
        'Reduce chargeback rate by 40%',
        'Accelerate cash flow cycle',
        'Improve user experience'
      ],
      cta: 'Connect E-commerce Solution'
    },
    gaming: {
      title: 'Gaming/Digital Content',
      subtitle: 'Gaming Entertainment Platforms',
      painPoints: [
        'High-frequency micro-payment transactions',
        'Arbitrage risk control',
        'Subscription/in-app purchase management',
        'Multi-platform payment unification'
      ],
      solutions: [
        'Low-amount high-frequency transaction optimization',
        'Multi-layer risk stratification strategy',
        'Top-up card/wallet integration',
        'Subscription management system'
      ],
      benefits: [
        'Improve user retention rate',
        'Increase ARPU value',
        'Reduce operational costs',
        'Optimize payment experience'
      ],
      cta: 'Consult Gaming Solution'
    },
    fintech: {
      title: 'Financial/Trading Platforms',
      subtitle: 'Fintech Services',
      painPoints: [
        'Anti-money laundering compliance requirements',
        'Funding channel stability',
        'Complex reconciliation',
        'Regulatory compliance costs'
      ],
      solutions: [
        'KYC/AML process integration',
        'Multi-active channel architecture',
        'Automated reconciliation tools',
        'Compliance report generation'
      ],
      benefits: [
        'Reduce compliance risks',
        'Lower operational costs',
        'Enhance fund security',
        'Simplify audit processes'
      ],
      cta: 'Contact Compliance Advisor'
    },
    saas: {
      title: 'Cross-border SaaS',
      subtitle: 'Subscription Service Platforms',
      painPoints: [
        'Cross-currency subscription deduction failures',
        'Complex tax processing',
        'Invoice management difficulties',
        'Renewal rate optimization'
      ],
      solutions: [
        'Localized payment options',
        'Smart retry mechanisms',
        'Automated bill generation',
        'Subscription lifecycle management'
      ],
      benefits: [
        'Improve subscription success rate',
        'Increase renewal rate',
        'Simplify financial processes',
        'Optimize cash flow'
      ],
      cta: 'Get Subscription Solution'
    }
  },
  cases: [
    {
      company: 'Cross-border E-commerce Platform',
      industry: 'E-commerce',
      challenge: 'Low payment conversion rate in Southeast Asian markets',
      result: '25% increase in conversion rate after integrating local wallets',
      metrics: 'Monthly transaction volume $2M+'
    },
    {
      company: 'Mobile Game Publisher',
      industry: 'Gaming',
      challenge: 'Unstable in-app purchase payment success rate',
      result: '98% success rate after payment process optimization',
      metrics: 'DAU 500K+'
    },
    {
      company: 'SaaS Service Provider',
      industry: 'SaaS',
      challenge: 'Low subscription renewal rate',
      result: '30% increase in renewal rate with localized payment options',
      metrics: 'Subscribers 10K+'
    }
  ]
};

export default solutions;